import {Main} from "../components/Main";
import routes from "../../../../../utils/routes";

import { RadioHead} from "../components/RadioHead";
import H2Header from "../components/H2Header";
import {Advertisement} from "../../../../../components/Advertisement/Advertisement";
import PageCss from "./page.module.scss";
import {SongRowList} from "../../../../../components/List/Song/SongRowList";
import {ProgramBoxList} from "../../../../../components/List/Podcast/ProgramBoxList";
import Markdown from "react-markdown";
import {useRadio} from "../../../../../contexts/useRadio";
import {useSuspenseQueries} from "@tanstack/react-query";
import {
    useRadioDescriptionKey,
    useRadioPodcastProgramsKey,
    useRadioSimilarKey,
    useRadioSongLastHourKey
} from "../../../../../queriesKeys/useRadioKey";
import {useOutlet, useParams} from "react-router-dom";
import {RouteLink} from "../../../../../components/RouteLink";
import Layout from "./layout";

import nextsvg from "../../../../../static/next1.svg";
import {useDebug} from "../../../../../contexts/useDebug";


const  RadioHomepageInner = () => {

    const { slug } = useParams();
    const radio = useRadio()!;

    const result = useSuspenseQueries({
        queries: [
            useRadioDescriptionKey(slug!, !!radio.hasDescription),
            useRadioSimilarKey(slug!, !!radio.hasSimilars),
            useRadioSongLastHourKey(slug!, !!radio.hasPlaylist),
            useRadioPodcastProgramsKey(slug!, !!radio.hasPodcasts)
        ]
    })

    const    [{
        data: desc,
    }, {
        data: similar,
    }, {
        data: songs,
    }, {
        data: podcasts
    }] = result;

    const outlet = useOutlet();
    const { advertisementDebug } = useDebug();

    return <>
        <RadioHead radio={radio}  />
                {(()=>{
                    if (outlet) {
                        return outlet;
                    }
                    return <>
                        <Main id="homepage" activeUrl={routes.radio_homepage(radio.slug)} radio={radio} similars={similar}>
                            {songs ?
                                <>
                                    <H2Header small={true}>
                                        <RouteLink to={routes.radio_playlist(slug!)}>Poslední odehrané skladby &nbsp;<img src={nextsvg} className={"align-self-center"} alt={""} /></RouteLink>
                                    </H2Header>
                                    <SongRowList items={songs.songs} twoItemsPerRow={true} />
                                    <hr/>
                                </> : false}
                            {podcasts && podcasts.count ?
                                <>
                                    <H2Header small={true}><RouteLink to={routes.radio_program(slug!)}>{"Podcasty"}&nbsp;<img src={nextsvg} className={"align-self-center"} alt={""} /></RouteLink></H2Header>
                                    <ProgramBoxList items={podcasts.result} />
                                </>: false}
                            {desc ?
                                <>
                                    <H2Header small={true}><RouteLink to={routes.radio_info(slug!)}>O rádiu &nbsp;<img src={nextsvg} className={"align-self-center"} alt={""} /></RouteLink></H2Header>
                                    <div className={PageCss.baseText} >
                                        {(()=>{
                                            if (desc.descriptionMarkdown) {
                                                return <Markdown className={"markdown-content"}>{desc.descriptionMarkdown}</Markdown>
                                            }
                                            else if (desc.description) {
                                                return <div dangerouslySetInnerHTML={{__html: desc.description ?? ""}}/>
                                            }
                                            else {
                                                return false;
                                            }
                                        })()}
                                    </div>

                                </>: false}
                        </Main>

                    </>
                })()}
    </>
}

export default function RadioHomePage () {
    return <Layout>
        <RadioHomepageInner />
    </Layout>
}